import VorVerifications from "./VorVerifications";

export default VorVerifications;
